import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import Button from "../../components/essentials/button/Button";
import AcedInput from "../../components/essentials/input/text/AcedInput";
import LoadingSpinner from "../../components/essentials/loading-spin/LoadingSpinner";
import { addErrorMessage } from "../../core/errors/errorSlice";
import { PasswordApiRoutes } from "../../shared/api-routes/auth/password-api.routes";
import { EMAIL_PATTERN } from "../../shared/const";
import http from "../../shared/utils/http";
import "./RecoverPassword.scss";

const RecoverPasswordRequest: React.FC = () => {
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    register,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
    },
  });

  const navigate = useNavigate();
  const { t } = useTranslation();

  // const isNumberValid = (_phone: any) => {
  //   return /([\+]\d{1,2})?[-\s\.]?[(]?\d{3}[)]?[-\s\.]?\d{3}[-\s\.]?\d{4}/.test(
  //     _phone
  //   );
  // };

  const dispatch = useAppDispatch();
  const onSubmit = (data: any) => {
    setLoading(true);
    http
      .post(PasswordApiRoutes.REQUEST_PASSWORD_RECOVER, {
        email: data.email,
      })
      .then((res) => {
        navigate("/sign-up/password-recovery/confirm");
      })
      .catch((error) => {
        setLoading(false);
        dispatch(addErrorMessage({ title: "Unexpected Error" }));
      });
  };

  const [isLoading, setLoading] = useState<boolean>(false);

  return (
    <div className="sign-up-email">
      <p className="sign-up-email__caption">
        {t("signUp.recoverPassword.emailTitle")}
      </p>

      <form className="sign-up-email__input" onSubmit={handleSubmit(onSubmit)}>
        <AcedInput
          placeholder={t("signUp.emailSection.inputPlaceHolderEmail")}
          control={control}
          name="email"
          rules={{
            required: t("signUp.emailSection.errors.required"),
            pattern: {
              value: EMAIL_PATTERN,
              message: t("signUp.emailSection.errors.pattern"),
            },
          }}
        />

        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <Button className="btn btn-primary">
            {t("common.buttons.next")}
          </Button>
        )}
      </form>
    </div>
  );
};

export default RecoverPasswordRequest;
